import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 24px;
  height: 24px;
  color: #000000;
`

const ArrowDown = ({ title = 'Arrow Down', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 24 24" title={title} {...rest}>
    <g
      className="prefix__nc-icon-wrapper"
      strokeLinecap="square"
      strokeWidth={2}
      stroke="currentColor"
      fill="none"
      strokeMiterlimit={10}
    >
      <path data-cap="butt" data-color="color-2" strokeLinecap="butt" d="M12 6v12" strokeWidth={1.2} />
      <path d="M16.2 13.8L12 18l-4.2-4.2" strokeWidth={1.2} />
    </g>
  </StyledIcon>
)

ArrowDown.needsWork = true
ArrowDown.displayName = 'ArrowDown'
export default ArrowDown
